export const buyers = [
  { name: 'María G.', country: 'Mexico', minutesAgo: 2 },
  { name: 'Carlos R.', country: 'Colombia', minutesAgo: 4 },
  { name: 'Lucía F.', country: 'Spain', minutesAgo: 1 },
  { name: 'Javier M.', country: 'Argentina', minutesAgo: 6 },
  { name: 'Valentina R.', country: 'Chile', minutesAgo: 3 },
  { name: 'Andrés C.', country: 'Peru', minutesAgo: 8 },
  { name: 'Camila H.', country: 'Ecuador', minutesAgo: 5 },
  { name: 'Diego R.', country: 'Guatemala', minutesAgo: 2 },
  { name: 'Sofía M.', country: 'Uruguay', minutesAgo: 7 },
  { name: 'Mateo V.', country: 'Costa Rica', minutesAgo: 3 },
  { name: 'Isabella T.', country: 'Dominican Republic', minutesAgo: 9 },
  { name: 'Gabriel S.', country: 'Venezuela', minutesAgo: 4 },
  { name: 'Daniela P.', country: 'Bolivia', minutesAgo: 1 },
  { name: 'Fernando O.', country: 'Paraguay', minutesAgo: 6 },
  { name: 'Paula N.', country: 'Puerto Rico', minutesAgo: 2 },
];
